import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { WorldClock } from './WorldClock';
const LOGO = 'https://cdn.magicpatterns.com/uploads/aMwwLZyx3YLk9Bxk1v1F75/Commercial_Bank_of_Ceylon_PLC_idy3NrkOGC_1.svg';
export function TopBar() {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
  const dateStr = new Intl.DateTimeFormat('en-GB', {
    weekday: 'long',
    day: '2-digit',
    month: 'long',
    year: 'numeric'
  }).format(now);
  const timeStr = new Intl.DateTimeFormat('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  }).format(now);
  return <motion.header initial={{
    opacity: 0,
    y: -16
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6
  }} className="relative flex items-center justify-between gap-4 px-4 py-2 rounded-xl shadow-[0_8px_24px_-12px_rgba(0,0,0,0.7)]" style={{
    background: 'linear-gradient(180deg, #052a52 0%, #03203f 100%)',
    border: '1px solid rgba(255,255,255,0.12)'
  }} data-id="element-121">
      <div className="absolute inset-x-0 top-0 h-[2px] bg-gradient-to-r from-[#0066B3] via-[#7FB539] to-[#0066B3] opacity-70 rounded-t-xl" data-id="element-122" />

      <div className="flex items-center shrink-0" data-id="element-123">
        <img src={LOGO} alt="Commercial Bank of Ceylon" className="h-14 w-auto" data-id="element-124" />
      </div>

      <div className="flex items-center gap-3 text-center" data-id="element-125">
        <div className="leading-tight text-right" data-id="element-126">
          <div className="text-[9px] uppercase tracking-[0.28em] text-white/60 font-semibold" data-id="element-127">
            Today
          </div>
          <div className="tracking-display text-base font-bold text-white" data-id="element-128">
            {dateStr}
          </div>
        </div>
        <div className="h-8 w-px bg-white/15" data-id="element-129" />
        <div className="font-mono-num text-base font-bold text-[#9ed957] leading-none" data-id="element-130">
          {timeStr}
          <span className="text-white/55 text-[10px] ml-1 font-semibold" data-id="element-131">
            IST
          </span>
        </div>
      </div>

      <WorldClock data-id="element-132" />
    </motion.header>;
}